import { SESSION_MERGE_EDUCATION_MODAL_ID } from '@/atoms/session-merge-onboarding-modal-ids';
import { useQueuedModal } from '@/hooks/useQueuedModal';
import dynamic from 'next/dynamic';
import { type ReactElement } from 'react';

import type { SessionMergeEducationModal as SessionMergeEducationModalType } from './session-merge-education-modal';

const SessionMergeEducationModal = dynamic<
  React.ComponentProps<typeof SessionMergeEducationModalType>
>(
  () =>
    import('./session-merge-education-modal').then((m) => ({
      default: m.SessionMergeEducationModal,
    })),
  { ssr: false }
);

/**
 * Code-splits the education modal so its bundle only loads once the queue
 * surfaces it. Mirrors `LazyWebDictationOnboardingModal`.
 */
export function LazySessionMergeEducationModal(): ReactElement | null {
  const { isOpen } = useQueuedModal(SESSION_MERGE_EDUCATION_MODAL_ID);
  return isOpen ? <SessionMergeEducationModal /> : null;
}
